import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';

// Hydrate persisted Zustand stores
import { useCartStore } from './stores/cart';
import { useThemeStore } from './stores/theme';

// Rehydrate persisted stores
useCartStore.persist.rehydrate();
useThemeStore.persist.rehydrate();

// Apply theme to document
const theme = useThemeStore.getState().theme;
document.documentElement.classList.toggle('dark', theme === 'dark');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
